module.exports = __webpack_public_path__ + "img/miniapp.20a09199.png";